import React, { useRef, useState } from "react"

// import { isEmpty } from "lodash"

import FORM_CONFIG, { SUCCESS_MSG } from "./config"
import DatePicker from "./elements/DatePicker"
import Form from "./elements/Form"
import LanguageSelect from "./elements/LanguageSelect"
import PhoneInput from "./elements/PhoneInput"
import Recaptcha from "./elements/Recaptcha"
import TermsConditions from "./elements/TermsConditions"
import TextInput from "./elements/TextInput"
import TimePicker from "./elements/TimePicker"
import { bookViewingMiniSchema } from "./schemas"
import {
  formTracking,
  formatDate,
  formatTime,
  generateUuid,
  getBitrixData,
  isProduction,
  postFormData,
  sendMail,
  sendToMortgageFunnel,
  useBlock,
} from "./utils"
import { CheckboxInput } from "./elements/CheckboxInput"
import useEmailContent from "@hooks/dataHooks/useEmailContent"
import { useGlobalStore } from "@stores/globalStore"
import TextAreaInput from "./elements/TextAreaInput"
const BookaViewingFormMini = ({ propertyURL, property, email, crm_negotiator_id }) => {
  const url = propertyURL || localStorage.getItem("propertyURL")
  const recaptchaRef = useRef()
  const data = useEmailContent()
  const { ipAddress, setgaEmail, setShowSuccessMsg } = useGlobalStore()

  const formConfig = FORM_CONFIG.bookViewing
  let emailContentTemp = data?.filter((item) => item.choose_template === formConfig?.emailTempUser);
  const emailContent = emailContentTemp[0]?.content?.data?.content;
  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = async (data) => {
    setIsLoading(true); // Start loading
    const ipList = await useBlock();
    const isBlocked = ipList?.ip?.some(item => item?.add_ip_address === ipAddress);
    const isBlocked1 = ipList?.email?.some(item => item?.email === data.email);
    setgaEmail(data?.email)
    const token = await recaptchaRef.current?.executeAsync()

   if (token) {
      const unique_id = generateUuid()
      const postData = {
        first_name: data.name?.split(" ")[0],
        ...data,
        date_time: "N/A",
        date: "N/A",
        time: "N/A",
        language: "N/A",
        agent_email: email,
        unique_id: unique_id,
        crm_negotiator_id: crm_negotiator_id,
        url,
        ...formConfig,
        extra: { formConfig, data, url },
        isProperty: true,
        isPropertyType: url?.includes("/buy/") ? "sales" : url?.includes("/let/") ? "lettings" : "",
        "g-recaptcha-response": token,
      }

      // if (data.needFiniancialAdvice) {
      //   postData.needFiniancialAdvice = "Yes"
      //   postData.message = `This lead needs financial advice. ${postData.message || ""
      //     }`
      // } else {
      //   postData.needFiniancialAdvice = "No"
      // }

      const bitrixData = getBitrixData(postData)

      const formData = new FormData()

      formData.append("data", JSON.stringify(bitrixData))

      recaptchaRef.current?.reset()
      if(isBlocked || isBlocked1){
        setIsLoading(false); // End loading
        return;
      }
      else {
        
        try {
          setTimeout(() => {
            setShowSuccessMsg(true)
          }, 1000)
          postFormData(formData);
          sendMail(bitrixData);
          formTracking({
            unique_id: unique_id,
            eventTracking: formConfig.eventTracking,
            formName: formConfig.form_name,
            email: data?.email,
            phone: data?.telephone
          })
        } catch (error) {
          setIsLoading(false); // End loading
          console.error("Error submitting form:", error);
        } finally {
          setIsLoading(false); // End loading
        }

     

       
      }

    }
  }

  return (
    <Form
      className="book-a-viewing-form"
      validationSchema={bookViewingMiniSchema}
      onSubmit={onSubmit}
      successMsg={SUCCESS_MSG}
      formname="bookaviewing"
      issale={url?.includes("buy")}
    >
      {/* <p className="para">Lorem ipsum dolor sit amet, consectetur adipiscing elit nam elementum lectus orci.</p> */}
      <div className="form-grid">
      <div className="row-full">
        <TextInput name="name" placeholder="Name" 
        // label="Name"
         />
         </div>
         <div className="row-full">
        <TextInput
          name="email"
          placeholder="Email"
          type="email"
          // label="Email"
        />
        </div>
        <div className="row-full">
        <PhoneInput name="telephone" 
        // label="Phone"
         />
        </div>
        <TextAreaInput
          name="message"
          placeholder="Message"
          // label="Message"
        />
        {/* <CheckboxInput
          name="needFiniancialAdvice"
          label="Interested in mortgage advice?"
          boxClassName="row-full"
        /> */}
        <div className="d-none"><TextInput name="emailContent" type="hidden" value={emailContent} /></div>
      </div>
      <div className="form-bottom">
        <button className="button button-primary" type="submit">
          <span>{isLoading ? "Loading..." : "Request Information"}</span>
        </button>
        <TermsConditions />
      </div>
      <Recaptcha recaptchaRef={recaptchaRef} />
    </Form>
  )
}

export default BookaViewingFormMini
